import { render, staticRenderFns } from "./dialog-bind-actresses.vue?vue&type=template&id=50134e37&scoped=true&"
import script from "./dialog-bind-actresses.vue?vue&type=script&lang=js&"
export * from "./dialog-bind-actresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50134e37",
  null
  
)

export default component.exports